export default {
  // exams: [],
  heartedFeedIds: [],
  heartedFeedCommentIds: [],
};
